import 'css-chunk:src/dev-tools/DevToolsView.module.scss';export default {
  "root": "DevToolsView_root",
  "root-expanded": "DevToolsView_root-expanded",
  "content": "DevToolsView_content",
  "tools": "DevToolsView_tools",
  "tools-content": "DevToolsView_tools-content"
};